<template>
  <v-container fluid>
    <v-card>
      <v-container fluid>
        <v-form :disabled="buscando" @submit.prevent="buscarItensCliente">
          <v-row>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.descricao"
                label="Descrição Item Cliente"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.ncm"
                label="NCM Item Cliente"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.codigoItem"
                label="Código do Item Cliente"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.codigoBarra"
                label="Código de Barra"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemVo.descricao"
                label="Descrição item VO"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemVo.ncm"
                label="NCM Item VO"
                :loading="buscando"
                type="number"
              />
            </v-col>

            <v-col cols="4" sm="4">
              <v-autocomplete
                v-model="filtro.outros"
                :items="itensOutrosFiltros"
                label="Outros filtros"
                :loading="buscando"
                clearable
                multiple
              >
                <template #selection="{ item }">
                  <v-chip color="white">{{ item }}</v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
              <v-btn class="ml-4" color="primary" outlined type="submit" :loading="buscando">
                <v-icon left> mdi-magnify </v-icon>
                Pesquisar
              </v-btn>
              <v-btn
                class="ml-4"
                color="normal"
                outlined
                type="submit"
                :loading="buscando"
                @click.stop.prevent="limparSelecaoDeFiltros"
              >
                <v-icon left> mdi-autorenew </v-icon>
                Limpar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-2">
      <v-container fluid>
        <v-form :disabled="!podeVincular() || buscando" @submit.prevent="buscarItensCliente">
          <v-row align="center" justify="center">
            <v-col>
              <v-autocomplete
                v-model="itemVoVinculo"
                :items="itensVO"
                label="Buscar Item VO para vincular"
                clearable
              />
            </v-col>

            <v-col class="d-flex align-center justify-center">
              <div class="d-flex align-center flex-column">
                <v-btn :disabled="!permiteRealizarVinculo" color="primary" @click="vincularItemVo">
                  Vincular selecionados ao Item VO
                </v-btn>

                <span v-if="!podeVincular()" class="red--text text-body-2">
                  Sem permissão para vincular
                </span>
              </div>

              <div class="d-flex align-center flex-column ml-3">
                <v-btn
                  :disabled="!permiteRealizarVinculo"
                  color="primary"
                  @click="copiarTributacao"
                >
                  Copiar tributação e vincular novo Item VO
                </v-btn>

                <span v-if="!podeVincular()" class="red--text text-body-2">
                  Sem permissão para vincular
                </span>
              </div>
            </v-col>
          </v-row>

          <v-divider />

          <v-row align="center" justify="center">
            <v-col>
              <v-autocomplete
                v-model="motivoLixo"
                :items="itensMotivoLixo"
                label="Escolha o motivo"
                clearable
              />
            </v-col>

            <v-col class="d-flex justify-center">
              <v-btn
                class="mr-3"
                color="primary"
                :loading="colocandoNoLixo"
                :disabled="!permiteColocarNoLixo"
                @click="colocarNoLixo"
              >
                Colocar no Lixo
              </v-btn>

              <v-btn
                color="primary"
                :loading="tirandoDoLixo"
                :disabled="itensClienteSelecionados.length === 0"
                @click="tirarDoLixo"
              >
                Tirar do Lixo
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-4">
      <v-container fluid>
        <v-data-table
          v-model="itensClienteSelecionados"
          :headers="headers"
          :loading="buscando"
          :items="itensCliente"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-options': [10, 20, 50, 100, 200, 300, 1000, 3000, 5000, 10000]
          }"
          show-select
        >
          <template #[`item.codigoItem`]="{ item }">
            <span>{{ item.codigoItem }}</span>
            <v-divider />
            <span>{{ item.itemVo ? item.itemVo.codigo : '' }}</span>
          </template>

          <template #[`item.codigoBarra`]="{ item }">
            <span>{{ item.codigoBarra }}</span>
            <v-divider />
            <span>{{ item.itemVo ? item.itemVo.codigoBarra : '' }}</span>
          </template>

          <template #[`item.descricaoItem`]="{ item }">
            <span>{{ item.descricaoItem }}</span>
            <v-divider />
            <span>{{ item.itemVo ? item.itemVo.descricao : '' }}</span>
          </template>

          <template #[`item.ncm.codigo`]="{ item }">
            <span>{{ item.ncm.codigo }}</span>
            <v-divider />
            <span>{{ item.itemVo ? item.itemVo.ncm.codigo : '' }}</span>
          </template>

          <template #[`item.desvincular`]="{ item }">
            <div class="d-flex flex-nowrap justify-center">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-icon v-on="on" @click="() => desvincularItemVo(item)"> mdi-close </v-icon>
                </template>

                <span>Desvincular</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </v-container>
</template>

<script>
import ItemClienteService from '@/services/atualizacao/itemCliente'
import ItensVOService from '@/services/itensVO/itensVO'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import { ID_TELA_DE_ITENS_CLIENTE } from '@/common/constants'
import { formataMotivoLixo } from '@/shareds/formatacoes'
import store from '@/store'

export default {
  components: {
    SnackbarMessage
  },

  data: () => ({
    name: 'TelaDeItensCliente',
    itensCliente: [],
    itensVO: [],
    headers: [
      { text: 'Código', value: 'codigoItem', divider: true },
      { text: 'Código Barra', value: 'codigoBarra', divider: true },
      { text: 'Item', value: 'descricaoItem', divider: true },
      { text: 'NCM', value: 'ncm.codigo', divider: true },
      { text: 'Fat R$', value: 'valorFaturado', divider: true },
      { text: 'Motivo Lixo', value: 'motivoLixo', divider: true },
      { text: '', value: 'desvincular', sortable: false }
    ],
    filtro: {
      itemCliente: {
        codigoItem: null,
        codigoBarra: null,
        descricao: null,
        ncm: null
      },
      itemVo: {
        descricao: null,
        ncm: null
      },
      outros: null
    },
    itensClienteSelecionados: [],
    itensOutrosFiltros: ['Somente NÃO VINCULADOS', 'Somente LIXO', 'Somente Itens na Auditoria'],
    itensMotivoLixo: [
      { text: 'Falta Código de Barra', value: 'FALTA_CODIGO_BARRA' },
      { text: 'Material não informado', value: 'MATERIAL_NAO_INFORMADO' },
      { text: 'Não Produto', value: 'NAO_PRODUTO' },
      { text: 'Uso Consumo', value: 'USO_CONSUMO' },
      { text: 'Conferir mais tarde', value: 'CONFERIR_MAIS_TARDE' },
      {
        text: 'Código de Barra pertence a outro produto',
        value: 'CODIGO_BARRA_PERTENCE_OUTRO_PRODUTO'
      },
      { text: 'Criar regra', value: 'CRIAR_REGRA' }
    ],
    itemVoVinculo: '',
    buscando: false,
    colocandoNoLixo: false,
    tirandoDoLixo: false,
    operacao: '',
    snackbar: new SnackBar(),
    showDialogEdicaoParam: false,
    showDialogCriacaoParam: false,
    showDialogLixo: false,
    motivoLixo: '',
    itensParam: {},
    ID_TELA_DE_ITENS_CLIENTE: ID_TELA_DE_ITENS_CLIENTE
  }),

  computed: {
    permiteRealizarVinculo() {
      return this.itemVoVinculo && this.itensClienteSelecionados.length > 0
    },
    permiteColocarNoLixo() {
      return this.motivoLixo && this.itensClienteSelecionados.length > 0
    }
  },

  created() {
    this.loadItensVO()
    if (this.$route.query.descricao) {
      this.filtro.itemCliente.descricao = this.$route.query.descricao
      this.buscarItensCliente()
    }
  },

  methods: {
    podeVincular() {
      return store.getters.verificaSeTemPermissao(ID_TELA_DE_ITENS_CLIENTE, 'ADICIONAR')
    },

    async buscarItensCliente() {
      this.buscando = true
      this.itensCliente = []

      if (!this.filtro.outros) this.filtro.outros = []

      const itensClienteLixo = await ItemClienteService.buscarItensClienteNoLixo()

      try {
        const response = await ItemClienteService.getAll({
          descricaoItemCliente: this.filtro.itemCliente.descricao || undefined,
          ncmItemCliente: this.filtro.itemCliente.ncm || undefined,
          codigoItemCliente: this.filtro.itemCliente.codigoItem || undefined,
          codigoBarra: this.filtro.itemCliente.codigoBarra || undefined,
          ncmItemVo: this.filtro.itemVo.ncm || undefined,
          descricaoItemVo: this.filtro.itemVo.descricao || undefined,
          somenteNaoVinculados: this.filtro.outros.includes('Somente NÃO VINCULADOS') || undefined,
          somenteLixo: this.filtro.outros.includes('Somente LIXO') || undefined,
          somenteItensAuditoria:
            this.filtro.outros.includes('Somente Itens na Auditoria') || undefined
        })

        this.itensCliente = response.map((itemCliente) => {
          const itemClienteLixo = itensClienteLixo.find(
            (itemClienteLixo) => itemClienteLixo.itemCliente.id === itemCliente.id
          )

          return { ...itemCliente, motivoLixo: formataMotivoLixo(itemClienteLixo?.motivoLixo) }
        })
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Ocorreu um erro ao buscar os itens de cliente'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.buscando = false
      }
    },

    async loadItensVO() {
      try {
        const response = await ItensVOService.getItens()
        this.itensVO = response.map((item) => ({
          text: `${item.descricao} ~ ${item.ncm ? item.ncm.codigo : 'Sem NCM'} ~ ${
            item.codigoBarra || 'Sem Código de Barra'
          }`,
          value: item.id
        }))
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Ocorreu um erro ao buscar os itens VO'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async vincularItemVo() {
      this.loading = true
      try {
        const itensClienteIds = this.itensClienteSelecionados.map((itemCliente) => itemCliente.id)

        const response = await ItemClienteService.addItemVoRelationship({
          itensClienteIds,
          itemVoId: this.itemVoVinculo
        })

        const itemVoVinculado = response[0].itemVo

        itensClienteIds.forEach((itemClienteId) => {
          let indice = this.itensCliente.findIndex(
            (itemCliente) => itemCliente.id === itemClienteId
          )

          this.itensCliente.splice(indice, 1, {
            ...this.itensCliente[indice],
            itemVo: itemVoVinculado
          })
        })

        this.snackbar.snackTextParam = 'Vínculo realizado com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        this.itensClienteSelecionados = []
        this.itemVoVinculo = ''

        this.buscarItensCliente()
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.loading = false
      }
    },

    async desvincularItemVo(itemCliente) {
      this.loading = true

      if (itemCliente.itemVo === undefined || itemCliente.itemVo === null) {
        this.snackbar.snackTextParam = 'Não existe nenhum vínculo para este item.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
        return
      }

      try {
        await ItemClienteService.removeItemVoRelationship(itemCliente.id, itemCliente.itemVo.id)

        const indice = this.itensCliente.indexOf(itemCliente)

        this.itensCliente.splice(indice, 1, {
          ...this.itensCliente[indice],
          itemVo: null
        })

        this.snackbar.snackTextParam = 'Vínculo removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        this.itensClienteSelecionados = []
        this.buscarItensCliente()
      } catch (err) {
        this.snackbar.snackTextParam = `${err.response.status} | ${
          err.response.data.message === undefined ? err.message : err.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.loading = false
      }
    },

    async copiarTributacao() {
      this.loading = true
      try {
        const itensClienteIds = this.itensClienteSelecionados.map((itemCliente) => itemCliente.id)

        await ItemClienteService.copiarTributacao({
          itensClienteIds,
          itemVoId: this.itemVoVinculo
        })

        this.snackbar.snackTextParam = 'Vínculo realizado com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        this.itensClienteSelecionados = []
        this.itemVoVinculo = ''

        this.buscarItensCliente()
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.loading = false
      }
    },

    async tirarDoLixo() {
      this.tirandoDoLixo = true

      const itensClienteIds = this.itensClienteSelecionados
        .map((itemCliente) => itemCliente.id)
        .join(',')

      try {
        await ItemClienteService.tirarDoLixo(itensClienteIds)

        this.itensCliente.forEach((itemCliente) => {
          this.itensClienteSelecionados.map((itemClienteSelecionado) => {
            if (itemCliente.id === itemClienteSelecionado.id) {
              delete this.itensCliente[this.itensCliente.indexOf(itemClienteSelecionado)].motivoLixo
            }
          })
        })

        this.snackbar.snackTextParam = 'Item Cliente removido do Lixo com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.tirandoDoLixo = false
      }
    },

    async colocarNoLixo() {
      this.colocandoNoLixo = true

      const itensClienteIds = this.itensClienteSelecionados.map((itemCliente) => itemCliente.id)

      try {
        await ItemClienteService.colocarNoLixo(itensClienteIds, this.motivoLixo)

        this.itensCliente.forEach((itemCliente) => {
          this.itensClienteSelecionados.map((itemClienteSelecionado) => {
            if (itemCliente.id === itemClienteSelecionado.id) {
              Object.assign(this.itensCliente[this.itensCliente.indexOf(itemClienteSelecionado)], {
                motivoLixo: formataMotivoLixo(this.motivoLixo)
              })
            }
          })
        })

        this.itensClienteSelecionados.forEach((itemClienteSelecionado) => {
          const indiceItemSelecionado = this.itensCliente.findIndex(
            (itemCliente) => itemCliente.id === itemClienteSelecionado.id
          )

          if (indiceItemSelecionado >= 0) this.itensCliente.splice(indiceItemSelecionado, 1)
        })

        this.snackbar.snackTextParam = 'Item Cliente movido para o Lixo com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.colocandoNoLixo = false
      }
    },

    limparSelecaoDeFiltros() {
      this.filtro = {
        itemCliente: {
          codigoItem: null,
          codigoBarra: null,
          descricao: null,
          ncm: null
        },
        itemVo: {
          descricao: null,
          ncm: null
        }
      }
    }
  }
}
</script>

<style>
.theme--light.v-data-table tr {
  height: 70px;
}
</style>
